import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { LabelField, LockedChip } from 'components'
import { OutboundTripListDto } from 'dtos/outboundTrips'
import { formatDateMoment } from 'utils'

interface OutboundTripsListCardProps {
  outboundTrip: OutboundTripListDto
}

export default function OutboundTripListCard({ children, outboundTrip }: React.PropsWithChildren<OutboundTripsListCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container direction='row' alignItems='flex-start' spacing={2}>
          <Grid container item md={4} sm={12} spacing={2}>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={4}>
                <LockedChip isLocked={outboundTrip.isLocked} />
              </Grid>

              <Grid item xs={8} sm='auto'>
                {children}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Trip #' value={outboundTrip.outboundTripNumber} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Trip Date' value={outboundTrip.outboundTripDate ? formatDateMoment(outboundTrip.outboundTripDate) : undefined} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Transporter Company' value={outboundTrip.outboundTransporterCompany} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='DOT #' value={outboundTrip.outboundTransporterCompanyDotNumber} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Trip Destination' value={outboundTrip.destinationCompany} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Trip Destination Address' value={outboundTrip.destinationAddress} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Drivers License Photo Uploaded' value={outboundTrip.isDriversLicensePhotoUploaded ? 'Yes' : 'No'} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Signed BOL Uploaded'
                value={outboundTrip.signedBOLUploadedDateTime ? formatDateMoment(outboundTrip.signedBOLUploadedDateTime) : undefined}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} md={8} container alignItems='flex-start'>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Last 6 Of VIN</TableCell>

                    <TableCell>Importer Stock #</TableCell>

                    <TableCell>Year</TableCell>

                    <TableCell>Make</TableCell>

                    <TableCell>Model</TableCell>

                    <TableCell>Exporter/Buyer</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {outboundTrip.vehicles.map((vehicle, index) => (
                    <TableRow key={vehicle.vin} sx={{ backgroundColor: index % 2 === 0 ? '#FCFCFD' : 'white' }}>
                      <TableCell>{vehicle.vin.substring(vehicle.vin.length - 6)}</TableCell>

                      <TableCell>{vehicle.importerStockNumber ?? '-'}</TableCell>

                      <TableCell>{vehicle.year}</TableCell>

                      <TableCell>{vehicle.make}</TableCell>

                      <TableCell>{vehicle.model}</TableCell>

                      <TableCell>{vehicle.exporterBuyerCompany}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
